import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useNavigate, Link } from 'react-router-dom';
import Leaderboards from './components/Leaderboards';
import IndividualScoreEntry from './components/IndividualScoreEntry';
import TeamScoreEntry from './components/TeamScoreEntry';
import AdminDashboard from './components/AdminDashboard';
import UpNext from './components/UpNext';


function TopNavigation({ activeSection, setActiveSection, isAuthenticated }) {
    const navigate = useNavigate();
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    // Function to handle navigation with full page refresh
    const handleNavigation = (path, section) => {
        if (['/admin', '/individual-score-entry', '/team-score-entry'].includes(path)) {
            // Force a full page refresh for these routes
            window.location.href = path;
        } else {
            // Use React Router navigation for other routes
            navigate(path);
            if (setActiveSection) setActiveSection(section);
        }
    };

    return (
        <div className="topnav">
            <a href="https://ScoreKeep.net" className="logo-link" target="_blank" rel="noopener noreferrer">
                <img src="/ScoreKeepTransparent2.webp" alt="ScoreKeep Logo" className="logo" />
            </a>
            
            <button
                type="button"
                className={activeSection === 'Leaderboards' ? 'active' : ''}
                onClick={() => handleNavigation('/', 'Leaderboards')}
            >
                Leaderboards
            </button>

            {isAuthenticated && (
                <div className={`dropdown ${isDropdownOpen ? 'show' : ''}`} onMouseLeave={() => setIsDropdownOpen(false)}>
                    <button
                        type="button"
                        className={activeSection.includes('ScoreEntry') ? 'active' : ''}
                        aria-haspopup="true"
                        aria-expanded={isDropdownOpen}
                        onClick={() => setIsDropdownOpen(prev => !prev)}
                    >
                        Score Entry
                    </button>
                    <div className="dropdown-content" role="menu">
                        <button
                            type="button"
                            role="menuitem"
                            onClick={() => {
                                setIsDropdownOpen(false);
                                handleNavigation('/individual-score-entry', 'IndividualScoreEntry');
                            }}
                        >
                            Individual Score Entry
                        </button>
                        <button
                            type="button"
                            role="menuitem"
                            onClick={() => {
                                setIsDropdownOpen(false);
                                handleNavigation('/team-score-entry', 'TeamScoreEntry');
                            }}
                        >
                            Team Score Entry
                        </button>
                    </div>
                </div>
            )}

            {isAuthenticated && (
                <button type="button" onClick={() => handleNavigation('/admin', 'Admin')}>
                    Admin Dashboard
                </button>
            )}

            {!isAuthenticated ? (
                <a href="/.auth/login/aadb2c">Login</a>
            ) : (
                <a href="/.auth/logout">Logout</a>
            )}
        </div>
    );
}

function Home() {
    const [activeSection, setActiveSection] = useState('Leaderboards');
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        // Fetch /.auth/me to determine authentication status
        fetch("/.auth/me")
            .then((res) => res.json())
            .then((data) => {
                if (data.clientPrincipal) {
                    setIsAuthenticated(true);
                } else {
                    setIsAuthenticated(false);
                }
            })
            .catch(() => setIsAuthenticated(false));
    }, []);

    return (
        <div className="home-page">
            <TopNavigation 
                activeSection={activeSection} 
                setActiveSection={setActiveSection}
                isAuthenticated={isAuthenticated}
            />
            
            <div className="content-area">
                {activeSection === 'Leaderboards' && <Leaderboards />}
            </div>
        </div>
    );
}

function NotFound() {
    return <h1>404 - Page Not Found</h1>;
}

function App() {
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        // Fetch authentication status
        fetch("/.auth/me")
            .then((res) => res.json())
            .then((data) => {
                if (data.clientPrincipal) {
                    setIsAuthenticated(true);
                } else {
                    setIsAuthenticated(false);
                }
            })
            .catch(() => setIsAuthenticated(false));
    }, []);
    
    return (
        <Router>
            <Routes>
                {/* This first route causes staticwebapp.config.json to handle auth paths rather than the react router*/}
                <Route path="/.auth/*" element={null} />
                {/* The remaining routes are handdled by the react router as normal*/}
                <Route path="/" element={<Home />} />
                <Route path="/up-next" element={
                    <div className="page-container">
                        <TopNavigation activeSection="UpNext" isAuthenticated={isAuthenticated} />
                        <div className="content-area">
                            <UpNext />
                        </div>
                    </div>
                } />
                <Route path="/individual-score-entry" element={
                    <div className="page-container">
                        <TopNavigation activeSection="IndividualScoreEntry" isAuthenticated={isAuthenticated} />
                        <div className="content-area">
                            <IndividualScoreEntry />
                        </div>
                    </div>
                } />
                <Route path="/team-score-entry" element={
                    <div className="page-container">
                        <TopNavigation activeSection="TeamScoreEntry" isAuthenticated={isAuthenticated} />
                        <div className="content-area">
                            <TeamScoreEntry />
                        </div>
                    </div>
                } />
                <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
        </Router>
    );
}

export default App;
